module.exports = __webpack_public_path__ + "img/tu4.65e8b200.png";